exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kayenta .titled-subsection h5 {\n  font-weight: 600;\n}\n.kayenta .titled-subsection hr {\n  margin-top: 0;\n}\n", ""]);

